import * as yup from "yup";

export const MonitoreoAireSchema = yup.object().shape({
  frecuencia: yup.object().required("errors.monitoreoAire.frecuencia.required"),
  descripcion: yup
    .string()
    .max(1024, "errors.monitoreoAire.descripcion.max")
    .required("errors.monitoreoAire.descripcion.required"),
});
